rem(window);
function rem(win) {
    var setFontSize = win.setFontSize = function (_width) {
        var docEl = document.documentElement;
        // 获取当前窗口的宽度
        var width = _width || docEl.clientWidth; // docEl.getBoundingClientRect().width;

        // 大于 1080px 按 1080
        if (width > 750) {
            width = 750;
        }

        var rem = width / 10;
        console.log(rem);

        docEl.style.fontSize = rem + 'px';

        // 部分机型上的误差、兼容性处理
        var actualSize = win.getComputedStyle && parseFloat(win.getComputedStyle(docEl)["font-size"]);
        if (actualSize !== rem && actualSize > 0 && Math.abs(actualSize - rem) > 1) {
            var remScaled = rem * rem / actualSize;
            docEl.style.fontSize = remScaled + 'px';
        }
    }

    var timer;
    //函数节流
    function dbcRefresh() {
        clearTimeout(timer);
        timer = setTimeout(setFontSize, 100);
    }

    //窗口更新动态改变 font-size
    win.addEventListener('resize', dbcRefresh, false);
    //页面显示时计算一次
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            dbcRefresh()
        }
    }, false);
    setFontSize();
}

// function adjustWarp(warpId = '#warp') {
//     // if (window.isMobile) return;
//     const $win = $(window);
//     const height = $win.height();
//     let width = $win.width();

//     // 考虑导航栏情况
//     if (width / height < 360 / 600) {
//         return;
//     }

//     width = Math.ceil(height * 360 / 640);

//     $(warpId).css({
//         height,
//         width,
//         postion: 'relative',
//         top: 0,
//         left: 'auto',
//         margin: '0 auto'
//     });

//     // 重新计算 rem
//     window.setFontSize(width);
// }


// 作者：任侠
// 链接：https://juejin.cn/post/6844903520437534727
// 来源：掘金
// 著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。
